import { h, Component } from 'preact';
import Wrapper from './wrapper';

if (module.hot) {
  require('preact/debug');
}

export default class App extends Component {
  updateTheme = strength => {
    document.body.className = strength;
  };

  render() {
    return (
      <div id="app">
        <Wrapper updateTheme={this.updateTheme} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/app.js